<template>
    <!-- StatsContainer.vue -->
    <base-container :items="items" :loading="loading" :title="title">
        <!-- Stats Cards -->
        <template v-slot:item="{item, tileHeight}">
            <v-col
                :id="item.uuid"
                :key="item.uuid"
                cols="12"
                lg="4"
                md="6"
            >
                <!-- Stats Card -->
                <stats-card :height="tileHeight" :item="item"></stats-card>
            </v-col>
        </template>
    </base-container>
</template>

<script>
    import BaseContainer from './BaseContainer'
    import StatsCard from '@/components/StatsCard'

    export default {
        name: 'StatsContainer',
        props: {
            /**
             * An array of items to display i.e. [{
             * uuid
             * title
             * unit
             * crisisValue
             * actionableBadValue
             * actionableGoodValue
             * goodValue
             * orderId
             * }]
             */
            items: {
                type: Array,
                required: true
            },
            /**
             * Toggle the skeleton loader
             */
            loading: {
                type: Boolean,
                default: false
            },
            /**
             * The title of the wallboard
             */
            title: {
                type: String,
                required: true
            }
        },
        components: {
            BaseContainer,
            StatsCard
        }
    }
</script>
